<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="report-page"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      :width="drawerWidth"
      mobile-break-point="1024"
      floating
      app>
      <div class="page-logo-container mx-auto my-5">
        <PosmLogo />
      </div>

      <div class="page-navigation-container d-flex flex-column flex-grow-1">
        <ReportSearchForm />
      </div>

      <!-- User Account Menu -->
      <UserMenu class="mt-auto" />
      <!-- User Account Menu -->
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Call Log Page Content -->
    <v-content >
      <v-toolbar class="flex-column pa-2" style="height: auto; min-height: 80px;">
       <div class="d-flex flex-wrap align-center mt-5 w-100">
          <v-app-bar-nav-icon
            class="page-drawer-toggle mr-0"
            @click="isDrawerOpen = !isDrawerOpen">
          </v-app-bar-nav-icon>

          <v-toolbar-title
            class="pl-0">
            <MainNavigationMenu />
          </v-toolbar-title>

          <v-spacer></v-spacer>
        </div>
      </v-toolbar>

      <!-- Call Log Tabs -->
      <div
        class="call-tabs mx-5"
        :class="isMobile ? '' : 'd-flex'">

        <div
          :class="isMobile ? 'w-100' : 'open-call-tabs'"
          v-if="openCalls.length
            && isPermittedAll([
                'CallsCreate',
                'CallsGetByID'
              ])">
          <v-tabs
            center-active
            show-arrows
            optional
            v-model="callLogTab">
            <!-- View/Edit Closed Call -->
            <v-tab
              v-if="activeCall.CallEndUtc"
              :key="activeCall.CallID"
              :to="`/call-log/${activeCall.CallID}`"
              exact>
              <div>
                <div class="d-flex align-center">
                  <span
                    v-if="$store.getters.isActiveCallDirty"
                    class="mr-1">
                    *
                  </span>
                  <span
                    class="customer-status-dot small mr-1"
                    :class="activeCall.Customer.CustomerStatusColor.CustomerStatusColorName">
                  </span>
                  {{activeCall.Customer.CustomerName}}
                </div>
                <small>{{activeCall.CallStartUtc | dateAtTime}}</small>
              </div>
            </v-tab>
            <!-- / View/Edit Closed Call -->

            <!-- Open Calls -->
            <v-tab
              v-for="call in openCalls"
              :key="call.CallID"
              class="open-call"
              :to="`/call-log/${call.CallID}`"
              exact>
              <div>
                <div class="d-flex align-center">
                  <span
                    v-if="call.CallID === activeCall.CallID
                    && $store.getters.isActiveCallDirty"
                    class="mr-1">
                    *
                  </span>
                  <span
                    class="customer-status-dot small mr-1"
                    :class="call.Customer.CustomerStatusColor.CustomerStatusColorName">
                  </span>
                  {{call.Customer.CustomerName}}
                </div>
                <small>{{call.CallStartUtc | dateAtTime}}</small>
              </div>
            </v-tab>
            <!-- / Open Calls -->
          </v-tabs>
        </div>
      </div>
      <!-- / Call Log Tabs -->

      <!-- Call Log Table -->
      <ReportTable
        class="page-content mx-5 my-5"
        :call-log="callLog"
      />
      <!-- / Call Log Table -->
    </v-content>
    <!-- / Call Log Page Content -->
  </div>
</template>

<script>
import _ from 'lodash';
import UserMenu from '../components/UserMenu.vue';
import ReportTable from '../components/ReportTable.vue';
import ReportSearchForm from '../components/ReportSearchForm.vue';
import MainNavigationMenu from '../components/MainNavigationMenu.vue';
import PosmLogo from '../components/PosmLogo.vue';

export default {
  name: 'ReportPage',
  components: {
    UserMenu,
    ReportTable,
    ReportSearchForm,
    MainNavigationMenu,
    PosmLogo,
  },
  data() {
    return {
      callLogFilter: '',
      callLogTab: 0,
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.checkDirtyBeforeRouteChange(next);
  },
  beforeRouteLeave(to, from, next) {
    this.checkDirtyBeforeRouteChange(next);
  },
  computed: {
    callLog() {
      return this.$store.state.callLog;
    },
    openCalls() {
      return this.$store.state.openCalls;
    },
    activeCall() {
      return this.$store.state.activeCall;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    checkDirtyBeforeRouteChange(next) {
      const goToNext = () => {
        this.$store.commit('setActiveCall');
        next();
      };

      if (this.$store.getters.isActiveCallDirty) {
        this.showConfirm(
          'Are you sure you want to leave this call without saving?',
          'You have unsaved changes',
        ).then(goToNext, _.noop);
      } else {
        goToNext();
      }
    },
  },
  created() {
    this.$store.dispatch('getReportCalls');
  },
};
</script>

<style lang="scss">
#report-page {
  .call-tabs {
    .v-tab {
      margin: 4px 2px;
    }

    .main-tabs {
      width: 162px;
      margin-right: 20px;

      .v-tabs-bar {
        padding: 0 2px;
      }

      .v-slide-group__prev,
      .v-slide-group__next {
        display: none;
      }
    }

    .open-call-tabs {
      width: calc(100% - 182px);
    }
  }
}
</style>
